export const PRIVACY_POLICY_LINK = `${process.env.PUBLIC_URL}/privacy-policy`;
export const TERMS_AND_CONDITION_LINK = `${process.env.PUBLIC_URL}/terms-and-conditions`;
export const COOKIE_POLICY_LINK =
  "https://drive.google.com/file/d/1p0zjAZ1_UKYiK4gFnpkLzN_8gy0E3td2/view?usp=drive_link";
export const DATA_POLICY_LINK =
  "https://drive.google.com/file/d/1bokZTczN9bwebi4-fSz7i0rOIeufxYoR/view?usp=drive_link";

export const TELEPHONE_NUMBER = "+3120 213 4466";
export const CONTACT_EMAIL = "contact@dataxplorer.org";
